import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import styles from './AuthorTag.module.css'

export interface AuthorTagProps extends HTMLAttributes<HTMLDivElement> {}

export default function AuthorTag({ className, ...props }: AuthorTagProps) {
	return (
		<div {...props} className={clsx(styles.root, className)}>
			作者
		</div>
	)
}
